import api from "../apiConfig";

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  getAll(data) {
    let params = "";
    if (data) {
      Object.keys(data).forEach(key => {
        params += `${key}=${data[key]}&`;
      });
    }
    return api.get(`/api/v1/products?${params}`);
  },
  serials(params) {
    return api.get(`/api/v1/product-serials`, { params });
  },
  ordered() {
    return api.post(`/api/v1/products/ordered`);
  },
  active(id, data) {
    return api.post(`/api/v1/products/active/${id}`, data);
  },
  getById(id) {
    return api.get(`/api/v1/products/${id}`);
  },
  update(id, data) {
    return api.post(`/api/v1/products/${id}`, data);
  },
  create(data) {
    return api.post(`/api/v1/products`, data);
  },
  delete(id) {
    return api.delete(`/api/v1/products/${id}`);
  },
}